import React from "react";
import PropTypes from "prop-types";

import ProjectPage from "components/Project/ProjectPage";
import DesktopProjectPage from "components/Project/DesktopProjectPage";
import MobileProjectPage from "./MobileProjectPage";
import TourModalContainer from "components/shared/Tour/TourModal/TourModalContainer";

import sessionStorageService from "services/sessionStorageService";
import localize from "lang/localize";

const propTypes = {
  isLoadingMore: PropTypes.bool,
  sessionKey: PropTypes.string,
  projectId: PropTypes.number /* Project ID */,
  id: PropTypes.string /* Category ID */,
  project: PropTypes.object.isRequired,
  projectImage: PropTypes.string,
  buttons: PropTypes.array,
  categories: PropTypes.array,
  topics: PropTypes.array.isRequired,
  more: PropTypes.bool,
  showcaseProject: PropTypes.object,
  popup: PropTypes.object,
  showPopup: PropTypes.bool.isRequired,
  handleClosePopupAlertDialog: PropTypes.func.isRequired,
  showShareGameDialog: PropTypes.bool.isRequired,
  handleOpenShareGameDialog: PropTypes.func.isRequired,
  handleCloseShareGameDialog: PropTypes.func.isRequired,
  handleMore: PropTypes.func,
  user: PropTypes.object,
  team: PropTypes.object,
  notifications: PropTypes.number.isRequired,
  inboxUnread: PropTypes.number.isRequired,
  language: PropTypes.string,
  /* Custom: Tour modal handlers */
  showTourModal: PropTypes.bool,
  handleKeyPress: PropTypes.func,
  handleSearchChange: PropTypes.func,
  handleSubmit: PropTypes.func
};

const defaultProps = {
  more: false
};

class CustomProjectPage extends ProjectPage {
  /* Custom: new function for rendering tour modal */
  renderTourModal() {
    return (
      <TourModalContainer
        projectId={this.props.projectId}
        showModal={this.props.showTourModal}
        handleCloseModal={this.props.handleCloseTourModal}
        language={this.props.language}
      />
    );
  }

  render() {
    const IS_640_DESKTOP_PROJECT =
      sessionStorageService.getItem("640_desktop_project") === "true"
        ? true
        : false;
    const FLAVOR_TEXT_ARR = [
      localize("showcase_suggestion_1", this.props.language),
      localize("showcase_suggestion_2", this.props.language),
      localize("showcase_suggestion_3", this.props.language)
    ];

    return (
      <div className="project container nopadding">
        {this.props.showPopup && this.renderPopupAlertDialog()}
        {this.props.showShareGameDialog && this.renderShareGameDialog()}
        {this.props.showTopicsListDialog && this.renderTopicsListDialog()}
        {/* Custom: tour modal rendered above DesktopProjectPage and MobileProjectPage */}
        {this.props.showTourModal && this.renderTourModal()}
        <div
          className={
            "desktop-project innerblock verticalpadding horizontalpadding pure-g bottompadding-floating" +
            (IS_640_DESKTOP_PROJECT ? " hide-below-md-640" : " hide-below-md")
          }
        >
          {/* Render desktop Project page here */}
          <DesktopProjectPage
            isLoadingMore={this.props.isLoadingMore}
            categoryId={this.props.id}
            categories={this.props.categories}
            topics={this.props.topics}
            more={this.props.more}
            randomNumber={this.state.randomNumber}
            flavorTextArr={FLAVOR_TEXT_ARR}
            showcaseProject={this.props.showcaseProject}
            addAnchors={this.addAnchors}
            handleMore={this.props.handleMore}
            renderTopics={this.renderTopics}
            language={this.props.language}
          />
        </div>
        <div
          className={
            "mobile-project" +
            (IS_640_DESKTOP_PROJECT ? " hide-from-md-640" : " hide-from-md")
          }
        >
          {/* Render mobile Project page here */}
          <MobileProjectPage
            project={this.props.project}
            projectId={this.props.projectId}
            projectImage={this.props.projectImage}
            buttons={this.props.buttons}
            topics={this.props.topics}
            user={this.props.user}
            team={this.props.team}
            categoryId={this.props.id}
            notifications={this.props.notifications}
            inboxUnread={this.props.inboxUnread}
            more={this.props.more}
            randomNumber={this.state.randomNumber}
            flavorTextArr={FLAVOR_TEXT_ARR}
            showcaseProject={this.props.showcaseProject}
            addAnchors={this.addAnchors}
            handleMore={this.props.handleMore}
            handleOpenShareGameDialog={this.props.handleOpenShareGameDialog}
            renderTopics={this.renderTopics}
            language={this.props.language}
            /* Custom: handler for opening tour modal */
            handleOpenTourModal={this.props.handleOpenTourModal}
            handleSubmit={this.props.handleSubmit}
            handleKeyPress={this.props.handleKeyPress}
            handleSearchChange={this.props.handleSearchChange}
          />
        </div>
      </div>
    );
  }
}

CustomProjectPage.propTypes = propTypes;
CustomProjectPage.defaultProps = defaultProps;

export default CustomProjectPage;
